import React from "react";

import "./whatsappGroup.scss";
import { useStaticQuery, graphql, Link } from "gatsby";

const WhatsappGroup = () => {
  const data = useStaticQuery(graphql`
    query whatsappGroup {
      allContentfulHome {
        group(field: id) {
          nodes {
            referenciaOrganismos {
              titulo
              tituloBoton
              tituloGeneral
              imagenPrincipal {
                file {
                  url
                }
              }
              redireccionBoton
              referenciaContenidos {
                imagenesPrincipal {
                  file {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }`
  )

  const pageData = data.allContentfulHome.group[0].nodes[0].referenciaOrganismos[8]

  return (
    <div className="whatsapp">
      <div className="whatsapp__logo">
        <img src={pageData.imagenPrincipal.file.url} alt="WhatsApp" />
      </div>
      <div className="whatsapp__content">
        <div className="whatsapp__content-background">
          <Link to={pageData.redireccionBoton} target="_blank" rel="noreferrer">
            <img
              className="whatsapp__imgMobile"
              src={pageData.referenciaContenidos[0].imagenesPrincipal[0].file.url}
              alt="Únete al grupo de conversación."
            />
            <img
              className="whatsapp__imgDesktop"
              src={pageData.referenciaContenidos[0].imagenesPrincipal[1].file.url}
              alt="Únete al grupo de conversación."
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default WhatsappGroup;
